module.exports = __webpack_public_path__ + "img/77.38656195.svg";